import { render, staticRenderFns } from "./XchangeCalculator.vue?vue&type=template&id=6a37c244&scoped=true&"
import script from "./XchangeCalculator.vue?vue&type=script&lang=js&"
export * from "./XchangeCalculator.vue?vue&type=script&lang=js&"
import style0 from "./XchangeCalculator.vue?vue&type=style&index=0&id=6a37c244&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a37c244",
  null
  
)

export default component.exports